// API
export const GET_ENCODER_ID_DATA_API =
	'ingester/mediaCoder/encoding/:encoder_id/details';

// Queries
export const ENCODER_ID_DATA = 'ENCODER_ID_DATA';
